
export function parseTrackedItems<T>(trackedArray: T[]) {
	const active: T[] = [];
	const ceased: T[] = [];

	if (trackedArray) {
		for(let item of trackedArray) {
			if (!(item as any).ceased) {
				active.push(item);
			} else {
				ceased.push(item);
			}
		}
	}

	return {
		active,
		ceased,
	};
}